/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import VaccinationSchedule from './vaccination-schedule';
import VaccinationScheduleDetail from './vaccination-schedule-detail';
import VaccinationScheduleUpdate from './vaccination-schedule-update';
import VaccinationScheduleDeleteDialog from './vaccination-schedule-delete-dialog';

const VaccinationScheduleRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<VaccinationSchedule />} />
    <Route path="new" element={<VaccinationScheduleUpdate />} />
    <Route path=":id">
      <Route index element={<VaccinationScheduleDetail />} />
      <Route path="edit" element={<VaccinationScheduleUpdate />} />
      <Route path="delete" element={<VaccinationScheduleDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default VaccinationScheduleRoutes;
